import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const FileCopyIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M21 9V6H7v3h14m0-6a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14M3 19h15v2H3a2 2 0 0 1-2-2V8h2z" />
  </SvgIcon>
);
FileCopyIcon.displayName = 'FileCopyIcon';
FileCopyIcon.muiName = 'SvgIcon';

export default FileCopyIcon;
